import Raven from 'raven-js';
import { useCallback } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { useDeleteProductById } from 'commerce-products-lib/hooks/useDeleteProductById';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { CloneProductActionContext } from '../contexts/CloneProductActionContext';
import { DeleteProductActionContext } from '../contexts/DeleteProductActionContext';
import { useProductData } from '../contexts/ProductDataContext';
import { useProductDeleteModal } from '../contexts/ProductDeleteModalContext';
import { UpdateProductActionContext } from '../contexts/UpdateProductActionContext';
import { trackDeleteProduct } from '../utils/trackEvent';
import { ProductsTracker } from '../utils/trackers';
import { useProductEditModal } from '../contexts/ProductEditModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductActionsProvider = ({
  onObjectCreate,
  onObjectUpdate,
  updatePreview,
  onObjectDelete,
  closeSidebar,
  children
}) => {
  var _product$objectId;
  const product = useProductData();
  const cloneProduct = useCallback((createdProductId, modifiedPropertyNames) => {
    onObjectCreate({
      associationType: PRODUCT_TYPE_ID,
      objectId: createdProductId,
      addAnother: false
    });
    CrmLogger.log('indexInteractions', {
      action: 'create product',
      subaction: `clone`
    });
    ProductsTracker.track('productPanelUsage', {
      action: 'Clone product',
      subAction: 'Save',
      propertyName: modifiedPropertyNames
    });
    updatePreview(PRODUCT_TYPE_ID, createdProductId);
  }, [onObjectCreate, updatePreview]);
  const {
    setIsEditModalOpen
  } = useProductEditModal();
  const updateProduct = useCallback(properties => {
    if (!(product !== null && product !== void 0 && product.objectId)) {
      const errorToThrow = new Error('Product objectId is not defined for updateProduct. This should never happen.');
      Raven.captureException(errorToThrow);
      throw errorToThrow;
    }
    setIsEditModalOpen(false);
    onObjectUpdate({
      objectId: product.objectId,
      objectType: PRODUCT_TYPE_ID,
      properties
    });
  }, [onObjectUpdate, product === null || product === void 0 ? void 0 : product.objectId, setIsEditModalOpen]);
  const {
    setIsDeleteModalOpen
  } = useProductDeleteModal();
  const deleteProductFromApi = useDeleteProductById((_product$objectId = product === null || product === void 0 ? void 0 : product.objectId) !== null && _product$objectId !== void 0 ? _product$objectId : null);
  const deleteProduct = useCallback(() => {
    if (!(product !== null && product !== void 0 && product.objectId)) {
      const errorToThrow = new Error('Product objectId is not defined for deleteProduct. This should never happen.');
      Raven.captureException(errorToThrow);
      throw errorToThrow;
    }
    deleteProductFromApi().then(() => {
      setIsDeleteModalOpen(false);
      onObjectDelete({
        objectTypeId: PRODUCT_TYPE_ID,
        objectId: String(product.objectId)
      });
      trackDeleteProduct();
      closeSidebar();
    }).catch(error => {
      setIsDeleteModalOpen(false);
      Raven.captureException(error);
      FloatingAlertStore.addAlert({
        message: unescapedText('modal.delete.error.message'),
        titleText: unescapedText('modal.delete.error.title'),
        type: 'danger'
      });
    });
  }, [onObjectDelete, closeSidebar, product, deleteProductFromApi, setIsDeleteModalOpen]);
  return /*#__PURE__*/_jsx(DeleteProductActionContext.Provider, {
    value: deleteProduct,
    children: /*#__PURE__*/_jsx(CloneProductActionContext.Provider, {
      value: cloneProduct,
      children: /*#__PURE__*/_jsx(UpdateProductActionContext.Provider, {
        value: updateProduct,
        children: children
      })
    })
  });
};